const comingSoonHandles = [''];

export default comingSoonHandles;
